import { useMountedRef } from "../../../hooks/use-mounted";
import { useLoadingSetState } from "../../../hooks";
import { WindowEasySizeT } from "./types";
import { LoadingStateOps } from "../../../domain/data-layer/loading-state";
import { useEffect, useRef } from "react";

export function useEasySizeScript(script: { src: string; integrity: string | undefined }) {
  const isMounted = useMountedRef();
  const [windowES, setWindowES, setFailed] = useLoadingSetState<{
    key: string;
    ref: React.RefObject<WindowEasySizeT | undefined>;
  }>(LoadingStateOps.loadingS);

  const ref = useRef<WindowEasySizeT | undefined>(undefined);

  useEffect(() => {
    const idKey = new Date().getDate().toString();

    const onLoad = () => {
      if (!isMounted.current) {
        return;
      }

      if (window.EasySize) {
        ref.current = window.EasySize;

        setWindowES({
          key: idKey,
          ref: ref,
        });
      } else {
        setFailed("no-easy-size-instance");
      }
    };

    const scriptEl = createHTMLScriptElement(document, script, idKey, {
      onLoad,
      onError: () => {
        setFailed("failed-loading-script");
      },
    });

    document.body.appendChild(scriptEl);

    return () => {
      document.querySelectorAll("#easysize_id").forEach(el => {
        el.remove();
      });

      document.body.removeChild(scriptEl);

      delete window.EasySize;
      //@ts-expect-error
      delete window.EasysizeWrapperInitiated;

      //@ts-expect-error
      delete window.EasysizeStarted;
    };
  }, []);

  return windowES;
}

function createHTMLScriptElement(
  globalDocument: Document,
  script: {
    src: string;
    integrity: string | undefined;
  },
  easySizeScriptId: string,
  callbacks: { onLoad: () => void; onError: () => void },
) {
  let scriptEl = globalDocument.createElement("script");

  // scriptEl.async = true;
  scriptEl.id = easySizeScriptId;
  scriptEl.onload = () => callbacks.onLoad();

  scriptEl.onerror = () => callbacks.onError();
  scriptEl.src = script.src;
  if (script.integrity) {
    scriptEl.integrity = script.integrity;
  }
  scriptEl.crossOrigin = "anonymous";

  return scriptEl;
}
